import { InputProps } from '@shopee-user/input';

function OneCredentialDelinkInputAuthKey(_: InputProps) {
  return null;
}

export default OneCredentialDelinkInputAuthKey;
